module.exports = __webpack_public_path__ + "img/dataCenterInfrastructure01.e0d63750.png";